const words = {
  spanish: {
    /* access: "Acceso Rápido", */
    home: "Inicio",
    services: "Servicios",
    us: "Nosotros",
    packages: "Planes y Reservas",
    contact: "Contáctenos",
    /*     packages: "Planes y Promociones",
    reviews: "Testimonios",
    contact: "Contáctenos",
    address: "primer restaurante a la izquierda",
    developper: "Desarrollado por",
    restaurant: "Restaurante",
    coffee: "Casita del Sabor",
    lodging: "Hospedaje",
    camping: "Campamento",
    games: "Atracciones",
    horse: "Paseos Ecológicos a Caballo y Caminatas",
    crafts: "Artesanías de la Región",
    glamping: "Glamping Cocora Nidos del Cóndor",
    flowers: "Vivero Cocora Viva", */
  },
  english: {
    /* access: "Quick Access", */
    home: "Home",
    services: "Services",
    us: "Us",
    packages: "Packages and Bookings",
    contact: "Contact Us",
    /*     packages: "Packages and Promotions",
    reviews: "Reviews",
    contact: "Contact Us",
    address: "first restaurant to your left",
    developper: "Developed By",
    restaurant: "Restaurant",
    coffee: "Coffee House",
    lodging: "Lodging",
    camping: "Camping",
    games: "Attractions",
    horse: "Horseback Riding",
    crafts: "Regional Crafts",
    glamping: "Glamping Cocora Nidos del Condor",
    flowers: "Florist Cocora Viva", */
  },
};

export default words;
